import { createGlobalStyle, css } from 'styled-components';
import { messageStyle } from '@devdept/samolet-ui/lib/components/message';
import { colors } from 'constants/colors';

const antStyle = css`
  // DROPDOWN
  .tend-ui-dropdown {
    & {
      li[type='divider'] {
        padding: 4px 16px 4px 16px !important;
        height: 1px;
        pointer-events: none;

        span {
          display: block;
          width: 100%;
          height: 1px;
          background-color: ${colors.gray100};
        }
      }
    }
  }

  // INPUT
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button,
  .ant-picker-now {
    display: none !important;
  }

  .ant-picker-time-panel-column:after {
    height: 0 !important;
  }

  .ant-picker-datetime-panel + .ant-picker-footer {
    display: none;
  }

  .ant-input[disabled],
  .ant-picker-input > input[disabled],
  .ant-input::placeholder,
  .ant-picker-input > input::placeholder,
  .ant-select-selection-placeholder,
  .ant-select-selection-item-content,
  .ant-empty-description,
  [data-testid='tend-ui-button'][disabled],
  .ant-checkbox-disabled + span {
    color: ${colors.grayBlue7};
  }

  // MODAL
  .ant-modal {
    padding-bottom: 0;
  }

  // LAYOUT
  main.ant-layout-content {
    height: auto;
  }

  // TABS
  .ant-tabs-content-holder {
    overflow-x: auto;
  }

  // MESSAGE
  .ant-message .ant-message-notice-content {
    max-height: 200px;
    overflow-y: auto;
  }

  // POPOVER
  .ant-popover-inner {
    border-radius: 8px;
    box-shadow: 0 8px 22px -6px rgba(24, 39, 75, 0.06),
      0px 14px 64px -4px rgba(24, 39, 75, 0.06);
  }

  .ant-popover-content .ant-popover-inner-content {
    padding: 16px;
  }

  .ant-popover-content .ant-popover-arrow {
    // заменить на <Popover arrow={false} после обновления анта
    display: none;
  }

  .ant-popover-message {
    padding-bottom: 16px;
  }

  // POPCONFIRM
  .ant-popconfirm {
    & .ant-popover-buttons {
      display: flex;
      flex-wrap: nowrap;
      justify-content: flex-end;
    }

    & button {
      height: 32px;
      border-radius: 8px;
      display: flex;
      padding: 6px 12px;
      justify-content: center;
      align-items: center;
      gap: 4px;
      font-size: 14px;
      line-height: 20px;
    }

    & button:first-child {
      border-color: transparent;
      box-shadow: none;

      &:not(:hover) {
        color: ${colors.gray900};
      }
    }

    & .ant-popover-message {
      padding-top: 0;
    }

    & .ant-popover-message-title {
      padding-left: 0;
    }
  }
`;

export const GlobalStyle = createGlobalStyle`
  #root {
    min-height: 100%;
  }

  html,
  body {
    -webkit-font-smoothing: antialiased;
    font-weight: 500;
  }

  body {
    color: ${colors.grayBlue8};
    overflow-y: auto;
  }

  ::-webkit-scrollbar-button {
    background-image: none;
    background-repeat: no-repeat;
    width: 5px;
    height: 0;
  }

  ::-webkit-resizer {
    background-image: none;
    background-repeat: no-repeat;
    width: 8px;
    height: 0;
  }

  ${antStyle}
  ${messageStyle}
`;
